import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import {
  createAttributeRule,
  IAttributeRulesResponseBody,
  ICreateAttributeRuleRequestBody,
} from 'src/api/createAttributeRule';
import { IAttributeRule } from 'src/types/menu.types';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from '../QueryKeys';

interface ICreateAttributeRuleVariables {
  payload: ICreateAttributeRuleRequestBody;
  file: File | null;
}

export const useCreateAttributeRule = (itemId: string, onMutationSuccess: (attributeRule: IAttributeRule) => void) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();

  return useMutation<IAttributeRulesResponseBody, Error, ICreateAttributeRuleVariables>(
    ({ payload, file }) => createAttributeRule(itemId, payload, file),
    {
      onSuccess: async ({ data: [attributeRule] }) => {
        await queryClient.invalidateQueries({ queryKey: [QueryKeys.item, itemId] });
        showSnackbar({
          status: SnackbarStatus.SUCCESS,
          message: `You have successfully created ${attributeRule.name}.`,
        });
        onMutationSuccess(attributeRule);
      },
      onError: (error, { payload }) => {
        captureException(error, { tags: { action: 'attribute_rule_create', attributeRuleName: payload.name } });
      },
    },
  );
};
